import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { applyMiddleware } from "redux";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import loadingSlice from "./reducers/loadingSlice";
import thunk from "redux-thunk";

import "antd/dist/antd.min.css";
import "./index.css";
import coursesSlice from "./reducers/coursesSlice";

const store = configureStore(
  {
    reducer: {
      loadingSlice,
      coursesSlice,
    },
  },
  applyMiddleware(thunk)
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
